import { render } from "./PaymentsManagerSettingsStage.vue?vue&type=template&id=615632f7&scoped=true"
import script from "./PaymentsManagerSettingsStage.vue?vue&type=script&lang=js"
export * from "./PaymentsManagerSettingsStage.vue?vue&type=script&lang=js"

import "./PaymentsManagerSettingsStage.vue?vue&type=style&index=0&id=615632f7&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-615632f7"]])

export default __exports__